import React from "react";
import { Eye } from "lucide-react";

const RATING_PILL = {
  CRITICAL: "bg-red-100 text-red-700",
  HIGH: "bg-orange-100 text-orange-700",
  MEDIUM: "bg-amber-100 text-amber-700",
  LOW: "bg-slate-100 text-slate-700",
};

/**
 * Step 11: Microsoft's own Purview DLP / Defender for Cloud Apps verdicts about sensitive data
 * reaching this AI app.
 *
 * Kept apart from the asset's posture risks because it is a different kind of claim: posture is what
 * Axaris assessed about the app, this is what Microsoft observed leaving for it. The heading says who
 * detected it and what Axaris does not do, so nobody reads the list as prompt inspection.
 */
export default function AiDataLeakFindings({ findings = [], onOpen }) {
  if (findings.length === 0) return null;
  return (
    <div data-testid="data-leak-findings">
      <div className="text-xs font-semibold text-content-secondary uppercase mb-1.5">
        Data leakage findings ({findings.length})
      </div>
      <div className="text-xs text-content-secondary mb-1.5">
        Detected by Microsoft Purview DLP or Defender for Cloud Apps and consumed by Axaris. Axaris
        does not inspect prompts or content, and does not block anything itself.
      </div>
      <div className="space-y-1.5">
        {findings.map((f) => (
          <div
            key={f.unifiedRiskId}
            className="w-full flex items-center gap-2 text-sm rounded-md px-1.5 py-1 -mx-1.5 hover:bg-theme-hover"
          >
            <span className={`px-2 py-0.5 rounded-full text-[11px] font-medium ${RATING_PILL[f.inherentRiskRating] || RATING_PILL.LOW}`}>
              {f.inherentRiskRating}
            </span>
            <span className="text-content-primary flex-1">{f.title}</span>
            <span className="text-content-secondary text-xs">
              {f.lastSeenAt ? new Date(f.lastSeenAt).toLocaleDateString() : ""}
            </span>
            <button
              onClick={() => onOpen?.(f.unifiedRiskId)}
              className="flex items-center gap-1.5 text-xs px-2.5 py-1 border rounded-lg font-medium transition-all bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-600 hover:text-white hover:border-emerald-600 active:scale-95"
              title="Open in the Risk Register — accept the risk, assign it, or track remediation there"
            >
              <Eye className="w-3 h-3" />
              View Risk
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
